module.exports = __webpack_public_path__ + "img/job.d1c72cf1.svg";